import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProfileRefreshModalComponent } from '../../modals/candidate/profile-refresh-modal/profile-refresh-modal.component';
import { AppConfigService } from '../http-services/app-config.service';
import { ProfileRefreshService } from '../http-services/profile-refresh.service';

@Injectable()
export class ProfileRefreshInterceptor implements HttpInterceptor {
  private static readonly profileRefreshDeniedCode = 40302;

  constructor(
    private router: Router,
    private appConfig: AppConfigService,
    private profileRefresh: ProfileRefreshService,
    private modalService: BsModalService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.isProfileRefreshError(error)) {
          this.handleBlockedApply();
        }
        return throwError(() => error);
      })
    );
  }

  private isProfileRefreshError(error: HttpErrorResponse): boolean {
    if (!this.appConfig.isProfileRefreshEnabled()) return false;

    const payload = error?.error;
    const code = Number(payload?.errorCode);
    if (code === ProfileRefreshInterceptor.profileRefreshDeniedCode) {
      return true;
    }

    const errors: string[] = Array.isArray(payload?.errors)
      ? payload.errors.map((e: unknown) => String(e))
      : [];
    const message = `${payload?.message ?? ''} ${errors.join(' ')}`.toLowerCase();
    return message.includes('profile refresh');
  }

  private handleBlockedApply(): void {
    const current = this.router.url || '';
    if (current.startsWith('/app/completion')) {
      return;
    }

    this.profileRefresh.loadStatus().subscribe(() => {
      const status = this.profileRefresh.snapshot;
      const config: ModalOptions<ProfileRefreshModalComponent> = {
        class: 'modal-dialog-centered modal-lg',
        initialState: {
          mode: (status?.status === 'InProgress' ? 'resume' : 'due') as 'resume' | 'due',
          lastCompletedStep: status?.lastCompletedStep || 0,
          totalSteps: status?.totalSteps || 8,
        },
      };
      this.modalService.show(ProfileRefreshModalComponent, config);
    });
  }
}
